// removed by extract-text-webpack-plugin
module.exports = {"header":"ScrollDownMenu__header___381Ox","main__heading":"ScrollDownMenu__main__heading___2MjfR","wrapper":"ScrollDownMenu__wrapper___1VQAh","logo":"ScrollDownMenu__logo___3FTvw","mobile__menu":"ScrollDownMenu__mobile__menu___3ZMuy","navigation":"ScrollDownMenu__navigation___3hTJQ","show__menu":"ScrollDownMenu__show__menu___12P5g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollDownMenu/ScrollDownMenu.scss
// module id = 83
// module chunks = 0